import moment from "moment";

function adicionaZero(numero){
    if (numero <= 9) 
        return "0" + numero;
    else
        return numero; 
}
export const dateUtils = value => {
    let data = value.split('T')[0].split('-');
    let newDate =data[2] + '/' +  data[1] + '/' + data[0]
    return newDate
};

export const dateFieldCombo = value => {
    let data = value.split('T')[0].split('-');

    console.log(data)
    let newDate = data[0] + '-' +  data[1] + '-' + data[2]
    return newDate
};

export const dateFilter = value => {
    console.log(value)
    let data = value.split('T')[0].split('-');

    console.log(data)
    let newDate = data[2] + '-' +  data[1] + '-' + data[0]
    return newDate
};